<template>
  <div class="reg-box">
    <a-row>
      <a-col :span="10">
        <h3 class="item-tit">
          源门店列表

          <a-input-search
            class="search-area"
            placeholder="门店名称"
            enter-button="搜索"
            @search="onSearch"
          />
        </h3>
        <div class="item-content">
          <a-radio-group
            v-model="orginShop"
            class="radio-box"
            @change="onChange"
          >
            <template v-for="item in shopOptions">
              <p class="g-title" v-if="item.CompanyList.length" :key="item.Id">
                {{ item.GroupName
                }}<span style="color:#f70;font-weight:bold"
                  >【{{ item.GroupCode }}】</span
                >
              </p>
              <a-radio
                :style="radioStyle"
                v-for="company in item.CompanyList"
                :value="company.Id"
                :key="company.Id"
              >
                {{ company.Name }}（{{ company.Code }}）
              </a-radio>
            </template>
          </a-radio-group>
        </div>
      </a-col>
      <a-col :span="14">
        <h3 class="item-tit">
          注册序列号
        </h3>
        <div class="item-content">
          <div class="store">
            <em>*</em>选择门店：<span v-if="company"
              ><strong>{{ company.Name }}</strong
              >（{{ company.Code }}）</span
            >
          </div>
          <data-form
            ref="regForm"
            :content="content"
            :data="formData"
            :fixedLabelWidth="true"
            :colnum="1"
            :showButton="false"
            style="width:600px;"
          >
          </data-form>
          <div class="reg-btns">
            <a-button type="primary" :loading="loading" @click="onSubmit"
              >注册</a-button
            >
            <a-button @click="$router.push({ name: 'ShopManage' })"
              >返回</a-button
            >
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { DataForm } from "@/components/dataForm";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    DataForm
  },
  data() {
    return {
      orginShop: "",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      shopOptions: [],
      allShopOptions: [],
      content: [
        {
          label: "有效日期",
          type: "date-range-picker",
          name: "DateRange",
          colnum: 2,
          option: {
            rules: [{ required: true, message: "有效日期必填" }]
          }
        }
      ],
      formData: {},
      company: {},
      allCompanys: [],
      loading: false,
      currentDate: ""
    };
  },
  created() {
    const Id = this.$route.query.Id;
    this.$post("CopyData_Companys", {}).then(res => {
      this.allShopOptions = res.Data;
      this.shopOptions = res.Data;
      this.shopOptions.forEach(el => {
        this.allCompanys = this.allCompanys.concat(el.CompanyList);
      });
      if (Id) {
        this.orginShop = Id;
        this.company = this.allCompanys.find(el => el.Id == this.orginShop);
      }
    });
  },
  methods: {
    onSearch(val) {
      this.shopOptions = cloneDeep(this.allShopOptions);
      this.shopOptions.forEach(el => {
        if (el.CompanyList && el.CompanyList.length) {
          const filterData = el.CompanyList.filter(item =>
            item.Name.includes(val)
          );
          el.CompanyList = filterData;
        }
      });
    },
    onChange() {
      this.company = this.allCompanys.find(el => el.Id == this.orginShop);
      // for (let i = 0; i < this.shopOptions.length; i++) {
      //   const el = this.shopOptions[i];
      //   if (el.CompanyList && el.CompanyList.length) {
      //     this.company = el.CompanyList.find(item => item.Id == this.orginShop);
      //     if (this.company) {
      //       break;
      //     }
      //   }
      // }
    },
    onSubmit() {
      this.$refs.regForm.getData(true).then(values => {
        if (!this.company.Id) {
          this.$message.error("请选择门店！");
          return false;
        }
        if (!values.DateRange[0] || !values.DateRange[1]) {
          this.$message.error("请选择有效日期！");
          return false;
        }
        let params = {
          UserCompanyId: this.company.Id,
          RegediterNumberInfo: {
            CompanyCode: this.company.Code,
            CompanyName: this.company.Name,
            BeginDate: moment(values.DateRange[0]).format("YYYY-MM-DD"),
            EndDate: moment(values.DateRange[1]).format("YYYY-MM-DD")
          }
        };
        this.loading = true;
        this.$post("Company_RegisterInVirtulGroup", params)
          .then(() => {
            this.$message.success("注册成功！");
            this.loading = false;
            this.orginShop = "";
            this.company = {};
            this.$refs.regForm.resetFields();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="less">
.reg-box {
  .item-content {
    margin: 0 20px 20px;
    border: 1px solid #eee;
    border-radius: 3px;
    height: calc(100vh - 225px);
    overflow: hidden;
    overflow-y: auto;
    .store {
      padding-left: 62px;
      margin-top: 30px;
      margin-bottom: 10px;
      em {
        color: #f00;
        margin-right: 3px;
      }
      strong {
        font-size: 16px;
        color: #333;
      }
    }
  }
  .item-tit {
    margin: 10px 20px 0;
    padding: 7px 0;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    .search-area {
      width: 300px;
      float: right;
    }
  }
  .reg-btns {
    margin-left: 140px;
    margin-top: 30px;
    button {
      margin-right: 20px;
    }
  }
  .radio-box {
    width: 100%;
    .g-title {
      background: #f5f5f5;
      padding: 3px 5px;
      color: #666;
      margin-top: 12px;
      &:first-child {
        margin-top: 0;
      }
    }
    .ant-radio-wrapper {
      padding-left: 15px;
      color: #000;
    }
    .ant-radio-wrapper-checked {
      background: #d3ebff;
    }
  }
}
</style>
